export function trim(input) {
    return input.replace(/^\s+|\s+$/g, '');
}

export function nl2br(input) {
    if (typeof input === 'undefined' || input === null) {
        return '';
    }

    const break_tag = '<br />';
    return (input + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + break_tag + '$2');
}